var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M714.2,275.8c-5.4-16.6-21.5-28-44.1-31.3l-184.3-26.8l-82.4-167c-10.1-20.5-25.9-32.2-43.4-32.2 s-33.3,11.8-43.4,32.2l-82.4,167L49.9,244.6c-22.6,3.3-38.7,14.7-44.1,31.3c-5.4,16.6,0.9,35.3,17.3,51.2l133.4,130L125,640.7 c-4,23.5,2.8,37.6,9.3,45.2c7.6,9,18.6,14,31.1,14c9.4,0,19.4-2.7,29.7-8.2L360,605l164.9,86.7c10.3,5.4,20.3,8.2,29.7,8.2l0,0 c12.5,0,23.6-5,31.1-14c6.5-7.7,13.3-21.7,9.3-45.2l-31.5-183.6l133.4-130C713.3,311.1,719.6,292.4,714.2,275.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star_fill.799fdbbe9ae94a5e089a9fdee1a6aa7b.svg";
export { ForwardRef as ReactComponent };